import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import config from '../config';

const BtnMail = () => {
    return (
        <Button href={`tel:${config.email}`} className='mt-2 btn-hermiona'>
            <FontAwesomeIcon icon={faEnvelope} /><span className='ms-2'>{config.email}</span>
        </Button>
    );
};

export default BtnMail;

